import React from 'react';
import { Box } from '@chakra-ui/react';

const OfferPage: React.FC = () => {
  // Add #toolbar=0 to hide toolbar
  const pdfUrl = '/documents/offer.pdf#toolbar=0&navpanes=0&scrollbar=0';

  return (
    <Box width='100%' height='100vh' position='relative'>
      <iframe
        src={pdfUrl}
        title='Special Offer PDF'
        width='100%'
        height='100%'
        style={{
          border: 'none',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      />
    </Box>
  );
};

export default OfferPage;
